// Drop-in replacement for lucide-react, backed by Google's Material Symbols
// (outlined style) instead of Lucide's stroke icons. Every export here matches
// a Lucide name 1:1 with the same size/className API, so call sites (<Camera
// size={16} className="..." />) did not need to change — only the import source did.
// Material Symbols has no brand/logo glyphs, so the 5 social-brand icons still
// come from lucide-react and are simply re-exported here.
import React from "react";
import { Facebook, Instagram, Twitter, Linkedin, Youtube } from "lucide-react";

import { ReactComponent as _Activity } from "@material-symbols/svg-400/outlined/monitoring.svg";
import { ReactComponent as _AlertTriangle } from "@material-symbols/svg-400/outlined/warning.svg";
import { ReactComponent as _Aperture } from "@material-symbols/svg-400/outlined/camera.svg";
import { ReactComponent as _ArrowDown } from "@material-symbols/svg-400/outlined/arrow_downward.svg";
import { ReactComponent as _ArrowLeft } from "@material-symbols/svg-400/outlined/arrow_back.svg";
import { ReactComponent as _ArrowRight } from "@material-symbols/svg-400/outlined/arrow_forward.svg";
import { ReactComponent as _ArrowUp } from "@material-symbols/svg-400/outlined/arrow_upward.svg";
import { ReactComponent as _ArrowUpDown } from "@material-symbols/svg-400/outlined/swap_vert.svg";
import { ReactComponent as _AtSign } from "@material-symbols/svg-400/outlined/alternate_email.svg";
import { ReactComponent as _Award } from "@material-symbols/svg-400/outlined/award_star.svg";
import { ReactComponent as _Baby } from "@material-symbols/svg-400/outlined/child_care.svg";
import { ReactComponent as _BadgeCheck } from "@material-symbols/svg-400/outlined/verified.svg";
import { ReactComponent as _Ban } from "@material-symbols/svg-400/outlined/block.svg";
import { ReactComponent as _BarChart3 } from "@material-symbols/svg-400/outlined/bar_chart.svg";
import { ReactComponent as _Bell } from "@material-symbols/svg-400/outlined/notifications.svg";
import { ReactComponent as _Bird } from "@material-symbols/svg-400/outlined/flutter_dash.svg";
import { ReactComponent as _BookOpen } from "@material-symbols/svg-400/outlined/auto_stories.svg";
import { ReactComponent as _Briefcase } from "@material-symbols/svg-400/outlined/work.svg";
import { ReactComponent as _Building2 } from "@material-symbols/svg-400/outlined/apartment.svg";
import { ReactComponent as _Calendar } from "@material-symbols/svg-400/outlined/calendar_month.svg";
import { ReactComponent as _Camera } from "@material-symbols/svg-400/outlined/photo_camera.svg";
import { ReactComponent as _Check } from "@material-symbols/svg-400/outlined/check.svg";
import { ReactComponent as _CheckCircle2 } from "@material-symbols/svg-400/outlined/check_circle.svg";
import { ReactComponent as _ChevronDown } from "@material-symbols/svg-400/outlined/keyboard_arrow_down.svg";
import { ReactComponent as _ChevronLeft } from "@material-symbols/svg-400/outlined/keyboard_arrow_left.svg";
import { ReactComponent as _ChevronRight } from "@material-symbols/svg-400/outlined/keyboard_arrow_right.svg";
import { ReactComponent as _ChevronUp } from "@material-symbols/svg-400/outlined/keyboard_arrow_up.svg";
import { ReactComponent as _Circle } from "@material-symbols/svg-400/outlined/circle.svg";
import { ReactComponent as _Clapperboard } from "@material-symbols/svg-400/outlined/movie.svg";
import { ReactComponent as _ClipboardList } from "@material-symbols/svg-400/outlined/assignment.svg";
import { ReactComponent as _Clock } from "@material-symbols/svg-400/outlined/schedule.svg";
import { ReactComponent as _Clock3 } from "@material-symbols/svg-400/outlined/schedule.svg";
import { ReactComponent as _Columns3 } from "@material-symbols/svg-400/outlined/view_column.svg";
import { ReactComponent as _ContactRound } from "@material-symbols/svg-400/outlined/contact_page.svg";
import { ReactComponent as _Copy } from "@material-symbols/svg-400/outlined/content_copy.svg";
import { ReactComponent as _CreditCard } from "@material-symbols/svg-400/outlined/credit_card.svg";
import { ReactComponent as _Download } from "@material-symbols/svg-400/outlined/download.svg";
import { ReactComponent as _Eye } from "@material-symbols/svg-400/outlined/visibility.svg";
import { ReactComponent as _EyeOff } from "@material-symbols/svg-400/outlined/visibility_off.svg";
import { ReactComponent as _FileSpreadsheet } from "@material-symbols/svg-400/outlined/table_chart.svg";
import { ReactComponent as _FileText } from "@material-symbols/svg-400/outlined/description.svg";
import { ReactComponent as _Film } from "@material-symbols/svg-400/outlined/movie.svg";
import { ReactComponent as _Globe } from "@material-symbols/svg-400/outlined/public.svg";
import { ReactComponent as _GripVertical } from "@material-symbols/svg-400/outlined/drag_indicator.svg";
import { ReactComponent as _Heart } from "@material-symbols/svg-400/outlined/favorite.svg";
import { ReactComponent as _Home } from "@material-symbols/svg-400/outlined/home.svg";
import { ReactComponent as _IdCard } from "@material-symbols/svg-400/outlined/badge.svg";
import { ReactComponent as _Image } from "@material-symbols/svg-400/outlined/image.svg";
import { ReactComponent as _ImageIcon } from "@material-symbols/svg-400/outlined/image.svg";
import { ReactComponent as _ImagePlus } from "@material-symbols/svg-400/outlined/add_photo_alternate.svg";
import { ReactComponent as _Info } from "@material-symbols/svg-400/outlined/info.svg";
import { ReactComponent as _KeyRound } from "@material-symbols/svg-400/outlined/key.svg";
import { ReactComponent as _Lamp } from "@material-symbols/svg-400/outlined/light.svg";
import { ReactComponent as _Landmark } from "@material-symbols/svg-400/outlined/account_balance.svg";
import { ReactComponent as _Layout } from "@material-symbols/svg-400/outlined/dashboard.svg";
import { ReactComponent as _LayoutDashboard } from "@material-symbols/svg-400/outlined/dashboard.svg";
import { ReactComponent as _LayoutGrid } from "@material-symbols/svg-400/outlined/grid_view.svg";
import { ReactComponent as _Lightbulb } from "@material-symbols/svg-400/outlined/lightbulb.svg";
import { ReactComponent as _Link2 } from "@material-symbols/svg-400/outlined/link.svg";
import { ReactComponent as _List } from "@material-symbols/svg-400/outlined/list.svg";
import { ReactComponent as _ListPlus } from "@material-symbols/svg-400/outlined/playlist_add.svg";
import { ReactComponent as _Loader2 } from "@material-symbols/svg-400/outlined/progress_activity.svg";
import { ReactComponent as _Lock } from "@material-symbols/svg-400/outlined/lock.svg";
import { ReactComponent as _LogIn } from "@material-symbols/svg-400/outlined/login.svg";
import { ReactComponent as _LogOut } from "@material-symbols/svg-400/outlined/logout.svg";
import { ReactComponent as _Mail } from "@material-symbols/svg-400/outlined/mail.svg";
import { ReactComponent as _MailCheck } from "@material-symbols/svg-400/outlined/mark_email_read.svg";
import { ReactComponent as _Map } from "@material-symbols/svg-400/outlined/map.svg";
import { ReactComponent as _MapPin } from "@material-symbols/svg-400/outlined/location_on.svg";
import { ReactComponent as _Menu } from "@material-symbols/svg-400/outlined/menu.svg";
import { ReactComponent as _MessageCircle } from "@material-symbols/svg-400/outlined/chat.svg";
import { ReactComponent as _Minus } from "@material-symbols/svg-400/outlined/remove.svg";
import { ReactComponent as _MonitorSmartphone } from "@material-symbols/svg-400/outlined/devices.svg";
import { ReactComponent as _Moon } from "@material-symbols/svg-400/outlined/dark_mode.svg";
import { ReactComponent as _MoreHorizontal } from "@material-symbols/svg-400/outlined/more_horiz.svg";
import { ReactComponent as _Mountain } from "@material-symbols/svg-400/outlined/landscape.svg";
import { ReactComponent as _MousePointerClick } from "@material-symbols/svg-400/outlined/ads_click.svg";
import { ReactComponent as _Move } from "@material-symbols/svg-400/outlined/open_with.svg";
import { ReactComponent as _Package } from "@material-symbols/svg-400/outlined/package_2.svg";
import { ReactComponent as _PartyPopper } from "@material-symbols/svg-400/outlined/celebration.svg";
import { ReactComponent as _Pause } from "@material-symbols/svg-400/outlined/pause.svg";
import { ReactComponent as _Pencil } from "@material-symbols/svg-400/outlined/edit.svg";
import { ReactComponent as _Phone } from "@material-symbols/svg-400/outlined/call.svg";
import { ReactComponent as _Plane } from "@material-symbols/svg-400/outlined/flight.svg";
import { ReactComponent as _Play } from "@material-symbols/svg-400/outlined/play_arrow.svg";
import { ReactComponent as _PlayCircle } from "@material-symbols/svg-400/outlined/play_circle.svg";
import { ReactComponent as _Plus } from "@material-symbols/svg-400/outlined/add.svg";
import { ReactComponent as _Power } from "@material-symbols/svg-400/outlined/power_settings_new.svg";
import { ReactComponent as _Printer } from "@material-symbols/svg-400/outlined/print.svg";
import { ReactComponent as _Radar } from "@material-symbols/svg-400/outlined/radar.svg";
import { ReactComponent as _Radio } from "@material-symbols/svg-400/outlined/radio_button_checked.svg";
import { ReactComponent as _Receipt } from "@material-symbols/svg-400/outlined/receipt_long.svg";
import { ReactComponent as _RefreshCcw } from "@material-symbols/svg-400/outlined/refresh.svg";
import { ReactComponent as _RefreshCw } from "@material-symbols/svg-400/outlined/refresh.svg";
import { ReactComponent as _RotateCw } from "@material-symbols/svg-400/outlined/rotate_right.svg";
import { ReactComponent as _Save } from "@material-symbols/svg-400/outlined/save.svg";
import { ReactComponent as _Scissors } from "@material-symbols/svg-400/outlined/content_cut.svg";
import { ReactComponent as _Search } from "@material-symbols/svg-400/outlined/search.svg";
import { ReactComponent as _SearchCheck } from "@material-symbols/svg-400/outlined/manage_search.svg";
import { ReactComponent as _Send } from "@material-symbols/svg-400/outlined/send.svg";
import { ReactComponent as _Settings } from "@material-symbols/svg-400/outlined/settings.svg";
import { ReactComponent as _Share2 } from "@material-symbols/svg-400/outlined/share.svg";
import { ReactComponent as _ShieldCheck } from "@material-symbols/svg-400/outlined/verified_user.svg";
import { ReactComponent as _Smartphone } from "@material-symbols/svg-400/outlined/mobile.svg";
import { ReactComponent as _Smile } from "@material-symbols/svg-400/outlined/mood.svg";
import { ReactComponent as _Sparkles } from "@material-symbols/svg-400/outlined/stars.svg";
import { ReactComponent as _Star } from "@material-symbols/svg-400/outlined/star.svg";
import { ReactComponent as _StickyNote } from "@material-symbols/svg-400/outlined/sticky_note_2.svg";
import { ReactComponent as _Sun } from "@material-symbols/svg-400/outlined/light_mode.svg";
import { ReactComponent as _Tag } from "@material-symbols/svg-400/outlined/sell.svg";
import { ReactComponent as _Tags } from "@material-symbols/svg-400/outlined/sell.svg";
import { ReactComponent as _Timer } from "@material-symbols/svg-400/outlined/timer.svg";
import { ReactComponent as _Trash2 } from "@material-symbols/svg-400/outlined/delete.svg";
import { ReactComponent as _Upload } from "@material-symbols/svg-400/outlined/upload.svg";
import { ReactComponent as _User } from "@material-symbols/svg-400/outlined/person.svg";
import { ReactComponent as _UserCheck } from "@material-symbols/svg-400/outlined/how_to_reg.svg";
import { ReactComponent as _UserPlus } from "@material-symbols/svg-400/outlined/person_add.svg";
import { ReactComponent as _UserRound } from "@material-symbols/svg-400/outlined/person.svg";
import { ReactComponent as _UserX } from "@material-symbols/svg-400/outlined/person_remove.svg";
import { ReactComponent as _Users } from "@material-symbols/svg-400/outlined/group.svg";
import { ReactComponent as _UtensilsCrossed } from "@material-symbols/svg-400/outlined/restaurant.svg";
import { ReactComponent as _Video } from "@material-symbols/svg-400/outlined/videocam.svg";
import { ReactComponent as _Wallet } from "@material-symbols/svg-400/outlined/account_balance_wallet.svg";
import { ReactComponent as _Wand2 } from "@material-symbols/svg-400/outlined/wand_stars.svg";
import { ReactComponent as _X } from "@material-symbols/svg-400/outlined/close.svg";
import { ReactComponent as _XCircle } from "@material-symbols/svg-400/outlined/cancel.svg";

function wrap(Svg) {
  return React.forwardRef(function MaterialIcon({ size = 24, className, strokeWidth, ...rest }, ref) {
    return <Svg ref={ref} width={size} height={size} className={className} fill="currentColor" aria-hidden="true" {...rest} />;
  });
}

export const Activity = wrap(_Activity);
export const AlertTriangle = wrap(_AlertTriangle);
export const Aperture = wrap(_Aperture);
export const ArrowDown = wrap(_ArrowDown);
export const ArrowLeft = wrap(_ArrowLeft);
export const ArrowRight = wrap(_ArrowRight);
export const ArrowUp = wrap(_ArrowUp);
export const ArrowUpDown = wrap(_ArrowUpDown);
export const AtSign = wrap(_AtSign);
export const Award = wrap(_Award);
export const Baby = wrap(_Baby);
export const BadgeCheck = wrap(_BadgeCheck);
export const Ban = wrap(_Ban);
export const BarChart3 = wrap(_BarChart3);
export const Bell = wrap(_Bell);
export const Bird = wrap(_Bird);
export const BookOpen = wrap(_BookOpen);
export const Briefcase = wrap(_Briefcase);
export const Building2 = wrap(_Building2);
export const Calendar = wrap(_Calendar);
export const Camera = wrap(_Camera);
export const Check = wrap(_Check);
export const CheckCircle2 = wrap(_CheckCircle2);
export const ChevronDown = wrap(_ChevronDown);
export const ChevronLeft = wrap(_ChevronLeft);
export const ChevronRight = wrap(_ChevronRight);
export const ChevronUp = wrap(_ChevronUp);
export const Circle = wrap(_Circle);
export const Clapperboard = wrap(_Clapperboard);
export const ClipboardList = wrap(_ClipboardList);
export const Clock = wrap(_Clock);
export const Clock3 = wrap(_Clock3);
export const Columns3 = wrap(_Columns3);
export const ContactRound = wrap(_ContactRound);
export const Copy = wrap(_Copy);
export const CreditCard = wrap(_CreditCard);
export const Download = wrap(_Download);
export const Eye = wrap(_Eye);
export const EyeOff = wrap(_EyeOff);
export const FileSpreadsheet = wrap(_FileSpreadsheet);
export const FileText = wrap(_FileText);
export const Film = wrap(_Film);
export const Globe = wrap(_Globe);
export const GripVertical = wrap(_GripVertical);
export const Heart = wrap(_Heart);
export const Home = wrap(_Home);
export const IdCard = wrap(_IdCard);
export const Image = wrap(_Image);
export const ImageIcon = wrap(_ImageIcon);
export const ImagePlus = wrap(_ImagePlus);
export const Info = wrap(_Info);
export const KeyRound = wrap(_KeyRound);
export const Lamp = wrap(_Lamp);
export const Landmark = wrap(_Landmark);
export const Layout = wrap(_Layout);
export const LayoutDashboard = wrap(_LayoutDashboard);
export const LayoutGrid = wrap(_LayoutGrid);
export const Lightbulb = wrap(_Lightbulb);
export const Link2 = wrap(_Link2);
export const List = wrap(_List);
export const ListPlus = wrap(_ListPlus);
export const Loader2 = wrap(_Loader2);
export const Lock = wrap(_Lock);
export const LogIn = wrap(_LogIn);
export const LogOut = wrap(_LogOut);
export const Mail = wrap(_Mail);
export const MailCheck = wrap(_MailCheck);
export const Map = wrap(_Map);
export const MapPin = wrap(_MapPin);
export const Menu = wrap(_Menu);
export const MessageCircle = wrap(_MessageCircle);
export const Minus = wrap(_Minus);
export const MonitorSmartphone = wrap(_MonitorSmartphone);
export const Moon = wrap(_Moon);
export const MoreHorizontal = wrap(_MoreHorizontal);
export const Mountain = wrap(_Mountain);
export const MousePointerClick = wrap(_MousePointerClick);
export const Move = wrap(_Move);
export const Package = wrap(_Package);
export const PartyPopper = wrap(_PartyPopper);
export const Pause = wrap(_Pause);
export const Pencil = wrap(_Pencil);
export const Phone = wrap(_Phone);
export const Plane = wrap(_Plane);
export const Play = wrap(_Play);
export const PlayCircle = wrap(_PlayCircle);
export const Plus = wrap(_Plus);
export const Power = wrap(_Power);
export const Printer = wrap(_Printer);
export const Radar = wrap(_Radar);
export const Radio = wrap(_Radio);
export const Receipt = wrap(_Receipt);
export const RefreshCcw = wrap(_RefreshCcw);
export const RefreshCw = wrap(_RefreshCw);
export const RotateCw = wrap(_RotateCw);
export const Save = wrap(_Save);
export const Scissors = wrap(_Scissors);
export const Search = wrap(_Search);
export const SearchCheck = wrap(_SearchCheck);
export const Send = wrap(_Send);
export const Settings = wrap(_Settings);
export const Share2 = wrap(_Share2);
export const ShieldCheck = wrap(_ShieldCheck);
export const Smartphone = wrap(_Smartphone);
export const Smile = wrap(_Smile);
export const Sparkles = wrap(_Sparkles);
export const Star = wrap(_Star);
export const StickyNote = wrap(_StickyNote);
export const Sun = wrap(_Sun);
export const Tag = wrap(_Tag);
export const Tags = wrap(_Tags);
export const Timer = wrap(_Timer);
export const Trash2 = wrap(_Trash2);
export const Upload = wrap(_Upload);
export const User = wrap(_User);
export const UserCheck = wrap(_UserCheck);
export const UserPlus = wrap(_UserPlus);
export const UserRound = wrap(_UserRound);
export const UserX = wrap(_UserX);
export const Users = wrap(_Users);
export const UtensilsCrossed = wrap(_UtensilsCrossed);
export const Video = wrap(_Video);
export const Wallet = wrap(_Wallet);
export const Wand2 = wrap(_Wand2);
export const X = wrap(_X);
export const XCircle = wrap(_XCircle);

export { Facebook, Instagram, Twitter, Linkedin, Youtube };
